import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, Text } from '@domain-group/suit-theme'

import EnabledPermission from '@components/EnabledPermission'

import { getCampaignType } from '@functions/campaign'

import type { CampaignModel } from '@models/types'

interface CreateArtworkProps {
  boxProps?: object,
  itemPayload: {
    callbacks: {
      createArtwork?: (redirectUrl?: string) => void,
    },
    campaign: CampaignModel,
  },
  redirectUrl?: string,
}

const CreateArtwork = (props: CreateArtworkProps) => {
  const {
    boxProps,
    itemPayload: {
      callbacks: {
        createArtwork,
      },
      campaign,
    },
    redirectUrl,
  } = props

  return (
    <Box
      alignItems="center"
      backgroundColor="white"
      borderRadius={5}
      border="1px dashed"
      borderColor="lineColor"
      justifyContent="space-between"
      marginTop="large"
      padding="large"
      {...boxProps}
    >
      <Text color="bodyFontLightColor" fontSize="xsmall">
        No Artwork Attached
      </Text>

      {!!createArtwork && (
        <EnabledPermission
          campaignType={getCampaignType(campaign)}
          permissionKey="campaign.artwork.manage"
        >
          <Button
            buttonStyle="secondaryCreate"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => createArtwork(redirectUrl)}
            size="small"
            // @ts-expect-error TS2322
            width="auto"
          >
            Create Artwork
          </Button>
        </EnabledPermission>
      )}
    </Box>
  )
}

export default CreateArtwork
